module.exports = __webpack_public_path__ + "static/media/b2.db6cea19.jpg";